import axios from 'axios';

const getDomain = (cluster) => {
    if (process.env.REACT_APP_STAGE === 'production'){
        return `https://c${cluster}.imonggo.com`
    }else{
        //return 'http://secure.myimonggo.com' 
        return 'https://www.imonggo.net'
    } 
}

export const c1Api =  axios.create({
    baseURL: `${getDomain(1)}/api/api_dashboard/`
});

export const c2Api =  axios.create({
    baseURL: `${getDomain(2)}/api/api_dashboard/`
});

export const c3Api =  axios.create({
    baseURL: `${getDomain(3)}/api/api_dashboard/`
});